import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import type { Ref } from "react";

export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
  text?: string;
  ref?: Ref<HTMLDivElement>;
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
};

function Loader({ className, size = "md", text, ref, ...props }: LoaderProps) {
  return (
    <div
      ref={ref}
      className={cn(
        "flex flex-col items-center justify-center gap-2",
        className,
      )}
      {...props}
    >
      <Loader2
        className={cn("animate-spin text-muted-foreground", sizeClasses[size])}
      />
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
    </div>
  );
}

export { Loader };
